"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isPendingReview = function isPendingReview(props) {
  if (props.contentType === 'Path') {
    var incompletePathLearnings = props.mappedOffers && props.mappedOffers.find(function (val) {
      return val.isGradable && ['na', 'NA'].indexOf(val.successStatus) !== -1;
    });

    if (incompletePathLearnings) {
      return true;
    }

    return false;
  }

  return props.isGradable && ['na', 'NA'].indexOf(props.successStatus) !== -1;
};

var _default = isPendingReview;
exports.default = _default;